import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/car/carTempcarFeePay/page/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/parkTempCarBill/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/parkTempCarBill/remove/v2', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/car/carTempcarFeePay/transferApply/v2', params, options);

export const update = (params, options) =>
  request.post('/api/parkTempCarBill/submit/v2', params, options);

// 获取提现账号信息
export const getTransferConfig = (params, options) =>
  request.get('/api/v4ward/pay/transferConfig/getTransferConfig/v2', Object.assign({}, options, {
    params
  }));

export const gettransferApplyList = (params, options) =>
  request.get('/api/v4ward/car/transferApply/page/v2', Object.assign({}, options, {
    params
  }));
export const getFeePayList = (params, options) =>
  request.get('/api/v4ward/car/carTempcarFeePay/getFeePayList/v2', Object.assign({}, options, {
    params
  }));
